import React from 'react'
import {Button} from './Button'
import {CalendarIcon} from './icons'
import {demoBookingUrl, signupModalHref} from './constants'

function TryItV2() {
  return (
    <section className="hlm-final" id="cta">
      <div className="hlm-container">
        <div className="hlm-cta-card">
          <div className="hlm-eyebrow">Get started</div>
          <h2 className="hlm-h2 hlm-cta-h2">Ready to take control of your listings?</h2>
          <p className="hlm-lede hlm-lede-center">
            Everything you need, from listing to close, in one secure place.
            <br />
            Book a live demo if you'd like to see it in action first.
          </p>
          <div className="hlm-cta-ctas">
            <Button href={signupModalHref} size="lg">
              Try it free
            </Button>
            <Button variant="secondary" size="lg" href={demoBookingUrl} target="_blank" rel="noopener noreferrer">
              <CalendarIcon />
              Book a demo
            </Button>
          </div>
          <div className="hlm-cta-foot">
            14-day free trial. No credit card required.
            <span className="hlm-cta-foot-note">Then subscribe to Pro for $39/mo, or stay on Basic free forever.</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TryItV2
